<section class="p-2 p-md-4">
  <div class="card">
    <div class="card-header bg-white b-none">
      <div class="d-flex mb-3" *ngIf="idUnidade">
        <div>
          <div class="text-truncate">ID</div>
          <div class="form-control disabled bg-light border-grey">{{unidadeSelecionada.id}}</div>
        </div>
        <div class="w-100 ml-3">
          <div class="text-truncate">Unidade</div>
          <div class="form-control disabled bg-light border-grey">{{unidadeSelecionada.nomeFantasia}}</div>
        </div>
      </div>
        <label for="nome-composta">Nome consulta {{nomeTipo}}</label>
        <input [formControl]="nomeConsulta" id="nome-composta" type="text" class="form-control">
        <app-msg-erro [control]="nomeConsulta"></app-msg-erro>
    </div>
    <div class="card-body">
      <div class="row">
        <h3 class="w-100 p-2 mt-2 modal-header mb-4 text-uppercase text-center">Consultas Veiculares</h3>
        <div *ngFor="let consulta of listaConsultas" class="col-12 col-md-6 col-xl-4 p-2">
          <app-checkbox size='lg' [label]="consulta.nome"
            [(checked)]="consulta.checked" [(disabled)]="consulta.disabled" (change)="count()"></app-checkbox>
        </div>
      </div>


      <div class="row mt-4">
        <h3 class="w-100 p-2 mt-2 modal-header mb-4 text-uppercase text-center">Consultas de Crédito</h3>
        <div *ngFor="let c of listaConsultasCredito" class="col-12 col-sm-6 col-md-4 p-2">
          <app-checkbox size='lg' [checked]="c.checked" (checkedChange)="selecionarCredito($event,c)" [label]="c.nome" [(disabled)]="c.disabled" (change)="count()"></app-checkbox>
        </div>
      </div>

    </div>
    <div class="card-footer bg-white d-flex justify-content-end">
      <button (click)="concluir()" [disabled]="nomeConsulta?.invalid || totalConsultas==0" class="btn btn-lg px-5 btn-success">
        <span>Salvar</span>
      </button>
    </div>
  </div>
</section>
